import { observer } from 'mobx-react';
import React from 'react';
import { T, TPlainTextKey } from '../../Translations';
import SortArrow from './SortArrow';
import { SortDirection } from '../../ListFilter/Types';

interface Props {
  columnName: TPlainTextKey;
  onSortClicked: () => void;
  sortKey: string;
  sortDirection: SortDirection;
  currentSortKey: string;
  className?: string;
  colSpan?: number;
}

const SortableColumn: React.FC<Props> = (props) => (
  <th className={props.className} colSpan={props.colSpan}>
    <a
      className="flex cursor-pointer"
      onClick={props.onSortClicked}
      data-sortkey={props.sortKey}
      data-intercom-target={`sort-by-${props.columnName.toString().toLowerCase().replace(/\s+/g, '-')}`}
    >
      <T kind={props.columnName} />
      <SortArrow
        sortKey={props.sortKey}
        sortDirection={props.sortDirection}
        currentSortKey={props.currentSortKey}
      />
    </a>
  </th>
);

export default observer(SortableColumn);
